var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-nav"},[_c('div',[_c('b-button',{staticClass:"mx-0 button is-subtle",attrs:{"disabled":_vm.$fetchState.pending || _vm.skipVal === 0,"icon-left":_vm.$fetchState.pending
                    ? 'fas fa-spinner fa-spin'
                    : 'fas fa-arrow-left'},on:{"click":_vm.pageDown}}),_vm._v(" "),_c('b-button',{staticClass:"mx-0 button is-subtle",attrs:{"disabled":_vm.$fetchState.pending || _vm.skipVal + _vm.firstVal >= _vm.totalMembers,"icon-left":_vm.$fetchState.pending
                    ? 'fas fa-spinner fa-spin'
                    : 'fas fa-arrow-right'},on:{"click":_vm.pageUp}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }